const config = require('./config');

module.exports = {
  jst(d) {
    if (!d) d = new Date;
    return new Date(d.getTime() + ((new Date().getTimezoneOffset() + (9 * 60)) * 60 * 1000));
  },
  jstToGmt(d) {
    return new Date(d.getTime() - 9 * 60 * 60 * 1000);
  },
  jpDate(date) {
    const year = config.yearsHash[date.getFullYear()];
    const month = date.getMonth() + 1;
    const mday = date.getDate();
    return `${year.jpYearName}${year.jpYear}年${month}月${mday}日`;
  },
  chunk(arrayData, chunkSize) {
    return Array.from({length: Math.ceil(arrayData.length / chunkSize)}, (v, i) => arrayData.slice(i * chunkSize, i * chunkSize + chunkSize));
  },
  trtcRoomId(memberId, castId) {
    return memberId + '0000' + castId;
  },
  log() {
    console.log.apply(null, [
      "%cTapFUn",
      "color:#fff; font-weight:bold; background-color:#666; padding:2px 4px; border-radius:4px;",
      ...arguments
    ]);
  },
  error() {
    console.error.apply(null, [
      "%cTapFUn",
      "color:fff; font-weight:bold; background-color:red; padding:2px 4px; border-radius:4px;",
      ...arguments
    ]);
  },
  variant(url, variant = 'public') {
    return url.replace(/\/[^\/]+$/, '/' + variant);
  },
}

